<div class="instructions-wrapper">
    @if (appFacadeService.isPaymentProcessorsAvailable() | async) {
    <p cdkOverlayOrigin #payMultipleContractTrigger="cdkOverlayOrigin" (click)="toggleOverlay('payMultipleContract')">
        {{ 'HowToPayMultipleContract' | translate }}
        <span porIcon icon="info"></span>
    </p>
    <p cdkOverlayOrigin #paySingleContractTrigger="cdkOverlayOrigin" (click)="toggleOverlay('paySingleContract')">
        {{ 'PaySingleContract' | translate }}
        <span porIcon icon="info"></span>
    </p>
    <por-overlay [featureName]="'multiple-payment-info'" [isOpen]="overlayStates.payMultipleContract" [trigger]="payMultipleContractTrigger" (closeOverlayClick)="toggleOverlay('payMultipleContract')">
        <h3>
            {{ 'PayMultipleContract' | translate }}
            <span>({{ 'InOnePayment' | translate }})</span>
        </h3>
        <p>{{ 'PayMultipleContractText_1' | translate }}</p>
        <p [innerHTML]="'PayMultipleContractText_2' | translate"></p>
        <p>{{ 'PayMultipleContractText_3' | translate }}</p>
        <p>{{ 'MinimumPaymentAmount' | translate }} {{ '1' | formatCurrency }} .</p>
        <p>{{ 'PayMultipleContractText_4' | translate }}</p>
    </por-overlay>
    <por-overlay [featureName]="'single-payment-info'" [isOpen]="overlayStates.paySingleContract" [trigger]="paySingleContractTrigger" (closeOverlayClick)="toggleOverlay('paySingleContract')">
        <h3>{{ 'WantPaySingleContract' | translate }}</h3>
        <p>{{ 'YouHaveTwoOptions' | translate }}</p>
        <ol class="number-list">
            <li>{{ 'PaySingleContractText_1' | translate }}</li>
            <li>{{ 'PaySingleContractText_2' | translate }}</li>
        </ol>
        <p>{{ 'PaySingleContractText_3' | translate }}</p>
        <p>{{ 'PaySingleContractText_4' | translate }}</p>
        <p>{{ 'MinimumPaymentAmount_2' | translate }} {{ '1' | formatCurrency }} .</p>
    </por-overlay>
    }
    <p cdkOverlayOrigin #viewContractDetailTrigger="cdkOverlayOrigin" (click)="toggleOverlay('viewContractDetail')">
        {{ 'ViewContractDetails' | translate }}
        <span porIcon icon="info"></span>
    </p>

    <por-overlay [featureName]="'view-contract-info'" [isOpen]="overlayStates.viewContractDetail" [trigger]="viewContractDetailTrigger" (closeOverlayClick)="toggleOverlay('viewContractDetail')">
        <h3>{{ 'ViewContractDetails' | translate }}</h3>
        <p>{{ 'ViewContractDetailText_1' | translate }}</p>
        <p>{{ 'ViewContractDetailText_2' | translate }}</p>
        <div class="list-item">{{ 'ViewContractDetailText_3' | translate }}</div>
        <div class="list-item">{{ 'ViewContractDetailText_4' | translate }}</div>
    </por-overlay>
</div>
